<template>
  <section>
    <div class="v-align">
      <div class="inner">
        <img class="trophy" src="../../../../../nextgen/src/assets/trophy.svg" />
        <p v-if="winner">Congratulations {{winner.name}}, you are the winner!</p>
      </div>
    </div>
  </section>
</template>

<script>
import {
  mapActions,
  mapState
} from 'vuex';

export default {
  name: 'Winner',
  data() {
    return {
      winner: undefined
    }
  },
  computed: {
    ...mapState('poll', [
      'group'
    ])
  },
  methods: {
    ...mapActions('voter', [
      'getLeaderboard'
    ])
  },
  async mounted() {
    try {
      [this.winner] = await this.getLeaderboard({ group: this.group });
    } catch (e) {
      this.winner = undefined;
    }
  }
}
</script>

<style scoped lang="scss">
section {
  position: absolute;
  top: 20px;
  left: 40px;
  right: 40px;
  bottom: 20px;
  margin: 0 auto;
  min-width: 140px;
  z-index: 100;
  text-align: center;

  > .v-align {
    display: table;
    margin: 0 auto;
    height: 100%;

    > .inner {
      display: table-cell;
      vertical-align: middle;
    }
  }

  .trophy {
    width: 70px;
  }
}

h2 {
  margin: 0 18px;
  font-size: var(--question-fontsize);
  color: var(--question-color);
  transition: all 500ms cubic-bezier(0.230, 1.000, 0.320, 1.000);
  text-align: left;
}

p {
  font-size: 22px;
}
</style>
